import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  Tooltip,
  Title,
  Legend,
  CategoryScale,
  LinearScale,
} from "chart.js";
import { useVarauskalenteritRaportointi } from "../Commoncontext/VarauskalenteritRaportointiContext";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Title, Legend);

const BarChart = ({ selectedMonths, setSelectedMonths }) => {
  const { raportointiData } = useVarauskalenteritRaportointi();
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [monthLabels, setMonthLabels] = useState([]); // Tallennetaan kuukausinimet tilaan

  useEffect(() => {
    if (!raportointiData || raportointiData.length === 0) return;
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const months = [];
    const fetchedData = [];
    for (let i = 12; i >= 0; i--) {
      let monthNumber = ((currentMonth - i + 12) % 12) || 12;
      let year = currentMonth - i <= 0 ? currentYear - 1 : currentYear;
      let monthKey = `${year}-${monthNumber}`;
      let monthLabel = new Date(year, monthNumber - 1)
         .toLocaleString("fi-FI", { month: "short" })
         .slice(0, 3);
      months.push({ key: monthKey, label: monthLabel });
      console.log("BarChart months: " + monthKey);
      const foundData = raportointiData.find((entry) => `${entry.vuosi}-${entry.kuukausi}` === monthKey);
      fetchedData.push(foundData?.totalReservations ?? 0); // Jos `undefined`, lisätään 0
    }
    setMonthLabels(months); // Tallennetaan kuukaudet tilaan
    const safeSelectedMonths = Array.isArray(selectedMonths) ? selectedMonths : [];
    const backgroundColors = months.map((month) =>
      safeSelectedMonths.includes(month.key) ? "#f5b400" : "#424242"
    );
    setChartData({
      labels: months.map((m) => m.label), // Käytetään lyhennettyjä nimiä
      datasets: [
        {
          label: "Varausmäärä",
          data: fetchedData,
          backgroundColor: backgroundColors,
        },
      ],
    });
  }, [raportointiData, selectedMonths]);

  const handleBarClick = (elements) => {
    if (elements.length > 0) {
      const monthIndex = elements[0].index;
      const monthKey = monthLabels[monthIndex]?.key; // Käytetään tilaan tallennettua kuukausiavainta
      if (!monthKey) return; // Varmistetaan, ettei undefined aiheuta virhettä
      setSelectedMonths((prev) =>
        prev.includes(monthKey) ? prev.filter((m) => m !== monthKey) : [...prev, monthKey]
      );
    }
  };

  return (
    <div style={{ width: "80%", height: "320px" }}>
      <Bar
        data={chartData}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          onClick: (_, elements) => handleBarClick(elements),
          plugins: {
            legend: { display: false },
            tooltip: {
              callbacks: {
                label: (tooltipItem) => `${tooltipItem.raw} kpl`,
              },
            },
          },
          scales: {
            x: { title: { display: true, text: "Kuukaudet" } },
            y: { title: { display: true, text: "Varausmäärä" }, beginAtZero: true },
          },
        }}
      />
    </div>
  );
};

export default BarChart;
